import React from "react";
import PropTypes from "prop-types";
import { RenderHTML } from "@learningblocks/shared-components";

export const CONSTANTS = {
  SMALL_WIDTH: 400,
  MOBILE_WIDTH: 767,
  SMALL_DESCRIPTION_WIDTH: 25,
  MOBILE_DESCRIPTION_LENGTH: 45,
  TABLET_DESCRIPTION_LENGTH: 44,
};

export function Description(props) {
  const renderDescription = () => {
    const currentScreenWidth = document.body.clientWidth;
    const trimmedDescription = props.trim
      ? currentScreenWidth < CONSTANTS.MOBILE_WIDTH
        ? currentScreenWidth < CONSTANTS.SMALL_WIDTH
          ? props.description.slice(0, CONSTANTS.SMALL_DESCRIPTION_WIDTH) +
            "..."
          : props.description.slice(0, CONSTANTS.MOBILE_DESCRIPTION_LENGTH) +
            "..."
        : props.description.slice(0, CONSTANTS.TABLET_DESCRIPTION_LENGTH) +
          "..."
      : props.description;

    const fullDescription = props.description.replace(/(<([^>]+)>)/gi, "");
    const renderTrimmedDescription = (
      <div {...(props.trim ? { "data-tooltip": fullDescription } : {})}>
        <RenderHTML content={trimmedDescription} />
      </div>
    );

    const renderNormalDescription = (
      <div>
        <RenderHTML content={props.description} />
      </div>
    );

    const checkDescriptionLength =
      currentScreenWidth < CONSTANTS.MOBILE_WIDTH
        ? currentScreenWidth < CONSTANTS.SMALL_WIDTH
          ? CONSTANTS.SMALL_DESCRIPTION_WIDTH
          : CONSTANTS.MOBILE_DESCRIPTION_LENGTH
        : CONSTANTS.TABLET_DESCRIPTION_LENGTH;

    if (props.description.length > checkDescriptionLength)
      return renderTrimmedDescription;
    else return renderNormalDescription;
  };
  return renderDescription();
}

Description.propTypes = {
  /**
   * text to be displayed in description
   */
  description: PropTypes.string,
  /**
   * Trim is a boolean used to ditermine wheather the description should trim or not
   */
  trim: PropTypes.bool,
};
